var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row login-details" }, [
      _c(
        "div",
        {
          staticClass:
            "col-lg-12 col-md-12 col-sm-12 col-xs-12 center centered",
        },
        [
          _c("div", { staticClass: "login-whitebox" }, [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.loginUser.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "login-input form-group col-sm-12 page_header",
                  },
                  [_vm._v(" Login with your account details below: ")]
                ),
                _c("div", { staticClass: "login-input form-group col-sm-12" }, [
                  _c("label", { attrs: { for: "email" } }, [_vm._v("Email")]),
                  _c("span", { staticClass: "required_astric" }, [_vm._v("*")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "email",
                      name: "email",
                      placeholder: "E-mail Address",
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "login-input form-group col-sm-12" }, [
                  _c("label", { attrs: { for: "password" } }, [
                    _vm._v("Password"),
                  ]),
                  _c("span", { staticClass: "required_astric" }, [_vm._v("*")]),
                  _c("div", { staticClass: "password-flex" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      ref: "inputTag",
                      staticClass: "form-control eye",
                      attrs: {
                        type: "password",
                        id: "password",
                        name: "password",
                        placeholder: "Password",
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.password = $event.target.value
                        },
                      },
                    }),
                    _vm.showPassword
                      ? _c("img", {
                          staticClass: "eye-icon",
                          attrs: {
                            src: "/static/images/icons/eye.svg",
                            alt: "eye-icon",
                          },
                          on: { click: _vm.toggleEye },
                        })
                      : _vm._e(),
                    !_vm.showPassword
                      ? _c("img", {
                          staticClass: "eye-slash-icon",
                          attrs: {
                            src: "/static/images/icons/eye_slash.svg",
                            alt: "eye-icon",
                          },
                          on: { click: _vm.toggleEye },
                        })
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "col-sm-12 emergo-button" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn emergo-green-button custom-padding",
                      attrs: {
                        disabled: _vm.disableSubmit || _vm.disableFormSubmit,
                        type: "submit",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.LoginButton) + " ")]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "pt-5 pb-0" },
                  [
                    _c("router-link", { attrs: { to: "/forgot" } }, [
                      _vm._v("Forgot your password?"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _vm._v(" Don't have an account yet? "),
                    _c("router-link", { attrs: { to: "/register" } }, [
                      _vm._v("Sign Up"),
                    ]),
                  ],
                  1
                ),
                _vm._m(0),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://rams-emergobyul.groovehq.com/help",
            target: "_blank",
          },
        },
        [_vm._v("FAQs")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }